import React from 'react';
import { Shield, DollarSign, Zap, Headphones } from 'lucide-react';
import { whyChooseUs } from '../data/mock';

const iconMap = {
  'Experienced IP Attorneys': Shield,
  'Transparent Pricing': DollarSign,
  'Fast & Reliable Filings': Zap,
  'End-to-End Legal Support': Headphones,
};

export const WhyChooseUs = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-[#D4AF37] font-semibold text-sm uppercase tracking-wider">Why Choose Us</span>
          <h2 className="text-4xl md:text-5xl font-bold text-[#0A1F44] mt-4 mb-6">
            The Otis Trademark Advantage
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We deliver superior brand protection through specialized legal expertise, crystal-clear processes, and unwavering client commitment that drives measurable business outcomes.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {whyChooseUs.map((feature) => {
            const Icon = iconMap[feature.title];
            return (
              <div
                key={feature.id}
                className="text-center space-y-4 group"
              >
                <div className="inline-flex items-center justify-center w-20 h-20 bg-[#0A1F44] rounded-full group-hover:bg-[#D4AF37] transition-colors duration-300">
                  <Icon className="w-10 h-10 text-[#D4AF37] group-hover:text-[#0A1F44]" />
                </div>
                <h3 className="text-xl font-bold text-[#0A1F44]">{feature.title}</h3>
                <p className="text-gray-600 leading-relaxed">{feature.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};